import { render, staticRenderFns } from "./TeamDetailDialog.vue?vue&type=template&id=082eaa30&scoped=true"
import script from "./TeamDetailDialog.vue?vue&type=script&lang=js"
export * from "./TeamDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./TeamDetailDialog.vue?vue&type=style&index=0&id=082eaa30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082eaa30",
  null
  
)

export default component.exports